/* ════ HISTORY VIEW (persistent activity log) ══════════════ */
import { state } from './state.js';
import { $ } from './dom.js';
import { MO } from './config.js';
import { displayName } from './utils/name.js';

const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const pad = n => String(n).padStart(2, '0');
function when(iso) {
  const d = new Date(iso);
  return `${d.getDate()} ${MO[d.getMonth()]} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function initHistory() {
  const inp = $('hist-search');
  if (inp) inp.addEventListener('input', e => { state.historySearch = e.target.value.trim().toLowerCase(); renderHistory(); });
}

export function renderHistory() {
  const wrap = $('history-rows'); if (!wrap) return;
  const q = state.historySearch;
  const rows = q
    ? state.activity.filter(a => `${a.actor || ''} ${a.action || ''} ${a.entity || ''} ${a.name || ''} ${a.detail || ''}`.toLowerCase().includes(q))
    : state.activity;
  if (!rows.length) { wrap.innerHTML = `<div class="list-empty">${q ? 'No matching history.' : 'No activity yet.'}</div>`; return; }
  wrap.innerHTML = rows.map(a => `
    <div class="hist-row">
      <div class="hist-when">${when(a.at)}</div>
      <div class="hist-main">
        <span class="hist-actor">${esc(displayName(a.actor || '') || 'Someone')}</span>
        <span class="hist-action">${esc(a.action || '')}</span>
        ${a.entity ? `<span class="hist-entity">${esc(a.entity)}</span>` : ''}
        ${a.name ? `<span class="hist-name">“${esc(a.name)}”</span>` : ''}
        ${a.detail ? `<span class="hist-detail">${esc(a.detail)}</span>` : ''}
      </div>
    </div>`).join('');
}
